<template>
  <div>
    <div style="font-size:16px;line-height:30px;width:70%">
      <div style="padding-bottom:20px">
        <p style="font-weight:bold">Hotel Accommodation Service</p>
        <p>Superb Events & Culture Media (Shanghai) Co., Ltd. is the official reception service agent for CAC2025.You can contact them for hotel reservation.</p>
      </div>
      <div>
        <p style="font-weight:bold">Contact</p>
        <p>Hu Jingpeng</p>
        <p>Superb Events & Culture Media (Shanghai) Co., Ltd.</p>
        <p>Room 252, North of Block B, Honggiao World Center, 1588 Zhuguang Rd., Shanghai, P. R. China</p>
        <p>Tel: 0086-15316571206</p>
        <p>E-mail:info@sbecm.com.cn, cac@sbecm.com.cn</p>
        <p>Web: www.sbecm.com.cn</p><br />
      </div>
      <div>
        <p style="font-weight:bold">NOTICE:</p>
        <p>Many room reservation centers contact exhibitors in the name of "the room reservation agent designated for the exhibition". Please carefully screen these agents to avoid inconvenience to your participation in the exhibition.</p>
      </div>
    </div>
    <div><el-button type="primary" :style="buttonStyle" @click="downfile" ><a href="https://www.sbecm.com.cn/conference/show?id=conference_4VJzvhK&lang=en" target="_bank" style="font-size:14px;color:#fff;text-decoration:none;" >Click to view details</a></el-button></div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      demoExcel:'./酒店预订介绍.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

